import { useMemo } from 'react';
import { User } from '../types/user.type';

export const useUserIsAgency = (user: User): boolean => useMemo(() => !!user?.agency, [user]);
